export { default } from './image-carousel.component';
